// extracted by mini-css-extract-plugin
export default {"wrapper":"Table_wrapper__plf61","table":"Table_table__9-ENW","row":"Table_row__fsTdH","col":"Table_col__6fLWr"};